export const SAVE_MENU_AUTH_DATA = "SAVE_MENU_AUTH_DATA";
export const RESET_MENU_AUTH_DATA = "RESET_MENU_AUTH_DATA";
export const SAVE_MULTI_LANG_DATA = "SAVE_MULTI_LANG_DATA";

export const saveMenuAuthData = (data) => ({
  type: SAVE_MENU_AUTH_DATA,
  payload: data,
});

export const resetMenuAuthData = () => ({
  type: RESET_MENU_AUTH_DATA,
});

export const saveMultiLangData = (data) => ({
  type: SAVE_MULTI_LANG_DATA,
  payload: data,
});
